import camelCase from "lodash-es/camelCase"
import mapKeys from "lodash-es/mapKeys"
import includes from "lodash-es/includes"
import {
  FONT_COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  inlineStyle,
} from "../../../../../style/const/chat/inline_style"

function createInlineStyleMap(strArr: string[]) {
  const styleMap = {}
  inlineStyle
    .filter(style => includes(strArr, style.name))
    .forEach(style => {
      styleMap[style.name] = mapKeys(style.css, (value, key) => camelCase(key))
    })
  return styleMap
}

// inline style
export const fontWeightSyleMap = createInlineStyleMap([FONT_WEIGHT.BOLD])

export const fontColorStyleMap = createInlineStyleMap([
  FONT_COLOR.BLUE,
  FONT_COLOR.GREEN,
  FONT_COLOR.ORANGE,
  FONT_COLOR.RED,
])

export const fontSizeStyleMap = createInlineStyleMap([
  FONT_SIZE.SMALL,
  FONT_SIZE.MEDIUM,
  FONT_SIZE.LARGE,
])
